<!-- TimesheetLayout.vue -->
<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">
        <leaves-admin-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          @AddEvent="AddEvent"
          :hasCreatePermission="hasCreatePermission"
        />

        <!-- <breadcrumb :title="title" :path="path" :text="text" /> -->

        <ul class="nav nav-tabs nav-tabs-bottom" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <router-link
              to="/timesheetdev/daily_review"
              class="nav-link"
              :class="{ active: isActive('daily_review') }"
              role="tab"
              aria-selected="isActive('daily_review')"
            >
              Daily Review
            </router-link>
          </li>
          <li class="nav-item" role="presentation">
            <router-link
              to="/timesheetdev/pay_period_review"
              class="nav-link"
              :class="{ active: isActive('pay_period_review') }"
              role="tab"
              aria-selected="isActive('pay_period_review')"
            >
              Pay Period Review
            </router-link>
          </li>
        </ul>

        <div class="tab-content">
          <router-view ref="activeTab" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { notification } from "ant-design-vue";

export default {
  data() {
    return {
      title: "Timesheet Review",
      path: "Dashboard",
      text: "Timesheet Review",
      text1: "Add Time card",
      hasReadPermission: null,
      hasCreatePermission: null,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    isActive(tabName) {
      return this.currentRouteName === tabName;
    },
    AddEvent() {
      console.log("timesheet called..");

      this.$nextTick(() => {
        const child = this.$refs.activeTab;
        console.log("🧩 Loaded component name:", child?.$options?.name); // should log: "DailyReview"

        if (child && typeof child.AddEvent2 === "function") {
          child.AddEvent2();
        } else {
          console.warn("❌ AddEvent2 not found on child:", child);
        }
      });
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", { module: "timing_sheet", action: "read" })
      .then((response) => {
        this.hasReadPermission = null;
        this.$nextTick(() => {
          this.hasReadPermission = response === "true";

          if (!this.hasReadPermission) {
            notification.open({
              message: "You don't have access to this page!",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            var user_role = window.localStorage.getItem("role");

            if (user_role && user_role.includes("Employee")) {
              this.$router
                .push({ name: "employee-dashboard" })
                .catch((error) => {});
            } else {
              this.$router
                .push({ name: "admin-dashboard" })
                .catch((error) => {});
            }
          }
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "timing_sheet", action: "create" })
      .then((response) => {
        this.hasCreatePermission = null;
        this.$nextTick(() => {
          this.hasCreatePermission = response === "true";
        });
      });
  },
};
</script>
